import { schema } from "normalizr";
import { Collection as CollectionRecord } from "records/collection";

export const Collection = new schema.Entity(
    "collections",
    {},
    {
        // TODO: Temporary for backend returning objects with { collection: null, permissions: [...] }
        // probably need to create a 2nd schema
        idAttribute: (value) => value.id || value.collection.id,
        processStrategy: (value) => {
            let brand_collection_properties = null;
            if (value.brand_collection_properties) {
                brand_collection_properties = value.brand_collection_properties;
            } else if (value.collection && value.collection.brand_collection_properties) {
                brand_collection_properties = value.collection.brand_collection_properties;
            }

            return {
                name: value.name || value.collection.name,
                created_at_ms: value.created_at_ms || value.collection.created_at_ms,
                id: value.id || value.collection.id,
                items_ref: value.items_ref || value.collection.items_ref,
                item_display_preferences_ref:
                    value.item_display_preferences_ref || value.collection.item_display_preferences_ref,
                root_ref: value.root_ref || value.collection.root_ref,
                brand_collection_properties,
            };
        },
    }
);

(Collection as any).record = CollectionRecord;
